import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { trackNavigationClicked } from 'util/trackingHelper';
import { NAV_SECTIONS } from 'util/trackNavigationClickedHelpers';

/**
 * The link to favorites is always shown post-auth when marketplace favorites are used.
 *
 * Favorites were migrated from inspiration to marketplace as part of INSPO-2415 and other tickets.
 *
 * @param {*} props
 */
const BoardHeart = (props) => {
  const {
    link,
    userContext: { is_guest: isGuest },
  } = props;

  const handleClick = useCallback(
    (event) => {
      event.preventDefault();
      trackNavigationClicked({
        menu_item: 'FAVORITES',
        section: NAV_SECTIONS.utility,
        node_level_1: 'FAVORITES',
      });

      // Wait 500ms before redirecting to be sure the event has been sent (it doesn't return a promise...)
      setTimeout(() => {
        window.location.href = link;
      }, 500);
    },
    [link]
  );

  if (isGuest !== false) {
    return null;
  }

  return (
    <a
      href={link}
      onClick={handleClick}
      className="nav-heart icon-link"
      aria-label="Your Favorites"
      title="Favorites"
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        className="nav-util__icon nav-heart__icon"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path fill="#fff" fillOpacity=".01" d="M0 0h20v20H0z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.534 2.592C3.552.44 6.807.411 8.858 2.505l.084.087L10 3.721l1.058-1.129c1.99-2.122 5.183-2.18 7.238-.173l.086.086.084.087c2.018 2.152 2.045 5.624.082 7.812l-.082.089-7.937 8.465a.715.715 0 01-1.017.04l-.041-.04-7.937-8.465c-2.045-2.182-2.045-5.719 0-7.9zm1.588 1.693c-1.147 1.223-1.169 3.192-.065 4.443l.065.072L10 16.136 16.88 8.8c1.146-1.224 1.168-3.192.081-4.426l-.064-.07-.066-.07a2.86 2.86 0 00-4.117-.018l-.068.07L10 7.105 7.354 4.286c-1.168-1.247-3.064-1.247-4.232 0z"
          fill="#505050"
        />
      </svg>
      <span className="hidden">Your Saved Ideas</span>
    </a>
  );
};

BoardHeart.propTypes = {
  userContext: PropTypes.shape({
    is_guest: PropTypes.bool,
  }),
  link: PropTypes.string.isRequired,
};

export default BoardHeart;
